import type React from "react";
import { useWorkspaceAdmin } from "@/hooks/use-workspace-admin";
import { PortfolioSafetyContent } from "@/pages/portfolio/safety-overview";

// A Workspace Admin's equivalent of the portfolio safety overview (UNB-1953),
// scoped to every brand owned by the workspace rather than just the brands the
// user was individually added to. Access itself is gated by `WorkspaceLayout`
// (UNB-2694) — this only mounts once that's confirmed.
export const WorkspaceSafetyOverview: React.FC = () => {
  const { workspace } = useWorkspaceAdmin();
  if (!workspace) return null;

  return <PortfolioSafetyContent merchants={workspace.merchants} workspaceId={workspace.id} />;
};
